import React, { Component } from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';

import { Button } from '../components/Button';

import { sortAttributes, splitCoordinates } from '../services/attributesServices';
import { PRIMARY_LIGHT } from '../constants/colors';
import { formatAtributeName } from '../services/formatAtributeName';
import { deleteConfirm } from '../services/deleteConfirm';
import { calculateColorFilterColor } from '../services/calculateColorFilterColor';

const CellComponent = styled.div`
  height: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.selected ? PRIMARY_LIGHT : props.level};
`;

const CellHeader = styled.span`
  width: auto;
  text-align: center;
  height: 100%;
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
  }
`;

export class MainTable extends Component {
  constructor(props) {
    super(props);
    this.onTdProps = this.onTdProps.bind(this);
    this.renderCheckBoxRow = this.renderCheckBoxRow.bind(this);
    this.handleRowSelect = this.handleRowSelect.bind(this);
    this.handleElementsDelete = this.handleElementsDelete.bind(this);
    this.state = {
      selected: [],
    };
  }

  onTdProps(state, rowInfo, column, instance) {
    return {
      onClick: () => this.props.handleRowSelect(state, rowInfo, column, instance),
    };
  }

  showUnits(type) {
    switch (type) {
      case 'air_humidity':
        return ' %';
      case 'air_temperature':
        return ' C';
      case 'rl':
      case 'rw':
      case 'qd':
        return <div>&nbsp;(mcd * lx<sup>-1</sup> * m<sup>-2</sup>)</div>; //eslint-disable-line
      default:
        return '';
    }
  }

  handleRowSelect(e) {
    const { value } = e.target;

    this.setState((prevState) => ({
      selected: prevState.selected.includes(value) ? prevState.selected.filter((item) => item !== value) : [...prevState.selected, value],
    }));
  }

  renderCheckBoxRow(cellInfo) {
    return (
      <input
        onChange={this.handleRowSelect}
        type="checkbox"
        checked={this.state.selected.includes(`${cellInfo.row.id}`)} // eslint-disable-line
        value={cellInfo.row.id}
      />
    );
  }

  handleElementsDelete() {
    this.props.deleteElement(this.state.selected);
  }

  render() {
    const {
      selected, selectedElementId, colorValues, colorFilter,
    } = this.props;

    const allElements = this.props.elements.map((item) => splitCoordinates(item));

    return (
      <ReactTable
        columns={[
          {
            Header: <Button disable={!this.state.selected.length > 0} onClick={(e) => deleteConfirm(() => this.handleElementsDelete(e))}><img src='./ic-delete-white.svg' /></Button>, // eslint-disable-line
            accessor: 'select',
            Cell: (row) => (
              <CellComponent
                selected={selectedElementId === row.original.id}
              >
                <input
                  onChange={this.handleRowSelect}
                  type="checkbox"
                  checked={this.state.selected.includes(`${row.row.id}`)} // eslint-disable-line
                  value={row.row.id}
                />
              </CellComponent>
            ),
            width: 60,
          },
          ...sortAttributes(selected).filter((item) => item.checked).map(({item}) => ({
            Header: <CellHeader>{formatAtributeName(item)}{this.showUnits(item)}</CellHeader>, // eslint-disable-line
            accessor: item,
            Cell: (row) => (
              <CellComponent
                selected={selectedElementId === row.original.id}
              >
                {selectedElementId === row.original.id && row.index > 10 && document.querySelector('.rt-tbody').scroll(0, (row.index * 25))}
                <span style={{
                  background: colorFilter !== 'false' ? calculateColorFilterColor(row.original[row.column.id], row.column.id || ' - ', colorValues) : 'transparent',
                  width: '100%',
                  height: '100%',
                }}
                >
                  {row.value || ' - '}
                </span>
              </CellComponent>
            ),
          }))]}
        data={allElements}
        defaultPageSize={allElements.length}
        pageSize={allElements.length}
        getTdProps={this.onTdProps}
        minRows={allElements.length}
        resizable
        showPageSizeOptions={false}
        showPagination={false}
        sortable={false}
        style={{height: '100%', width: '100%', maxWidth: '1920px'}}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MainTable.js